// extracted by mini-css-extract-plugin
module.exports = {"reviews":"carrier-review_reviews__Xj393","rating":"carrier-review_rating__7XLJk","logo":"carrier-review_logo__6oiFw","text":"carrier-review_text__0N91q"};